// eslint-disable-next-line import/prefer-default-export
export const Constants = {
  // App

  DISPLAY_IS_TEST_PLATFORM: import.meta.env.VITE_DISPLAY_IS_TEST_PLATFORM
    ? import.meta.env.VITE_DISPLAY_IS_TEST_PLATFORM.toLowerCase() === "true"
    : false,
  // Api
  API_URL: `${
    import.meta.env.VITE_API_URL ?? "https://rizcopp-develop.informez-moi.fr"
  }/api`,
  ROOT_URL:
    import.meta.env.VITE_API_URL ?? "https://rizcopp-develop.informez-moi.fr",
  // Google Maps
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
};
